let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ifpQG")).then(() => parcelRequire('b6nGj'));